import React, { createContext, useContext, useState, useEffect } from 'react';

import { tokenService, api } from './lib/api';


// Create the context
const AuthContext = createContext(undefined);

// Custom hook for using the auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [userId, setUserId] = useState(() => {
    // Initialize state from localStorage on component mount
    return localStorage.getItem('userId');
  });

  const login = async (email, password) => {
    try {
      const response = await api.post('/user/login', { email, password });
      console.log('response', response);
      if (response.status === 200) {
        tokenService.setTokens(
          response.data.token,
          response.data.refreshToken,
          response.data.agent.id,
          response.data.agent.profileImage
        );
        setUserId(response.data.agent.id);
        return true;
      }
      return false;
    } catch (error) {
      return false
    };
  }

    const logout = () => {
      tokenService.clearTokens();
      setUserId(null);
    };

    // Optional: Check token expiration on mount and during runtime
    // useEffect(() => {
    //   const checkSession = () => {
    //     const storedUserId = localStorage.getItem('userId');
    //     if (storedUserId) {
    //       // You can add additional validation here
    //       // For example, check if the token is expired
    //       setUserId(storedUserId);
    //     }
    //   };

    //   // Check on mount
    //   checkSession();

    //   // Optional: Periodically check session
    //   const interval = setInterval(checkSession, 1000 * 60 * 5); // Every 5 minutes

    //   return () => clearInterval(interval);
    // }, []);

    return (
      <AuthContext.Provider value={{ userId, login, logout }}>
        {children}
      </AuthContext.Provider>
    );
  };